import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class EmailReportStore {
  emailStore = [];
  reportNames = [];
  reportsList = [];
  groupList = [];
  subGroupList = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      emailStore: observable,
      loading: observable,
      reportNames: observable,
      reportsList: observable,
      total: observable,
      groupList: observable,
      subGroupList: observable,
      loadData: action,
      addData: action,
      getVehicles: action,
      deleteRecord: action,
      getEmailReportData: action,
      getReportsName: action,
      getVehicleGroup: action,
      getVehicleSubGroup: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;

    const params = { companyId: companyId };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("/EmailReport/getErList", { params });

    this.emailStore = response?.data?.data;
    // var postData = { companyId: companyId, offset: offset, limit: limit };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=getErList", "postData=" + base64Input);

    // this.emailStore = response?.data?.data?.erList;
    // this.total = parseInt(response.data.data.TotalCount);
    this.loading = false;
  }
  async addData(emailReportData) {
    // const emailData = {
    //   emailReportData,
    // };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("/EmailReport/addUpdateEmailData", emailReportData);
    // var postData = emailReportData;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=update", "postData=" + base64Input);
    return response.data;
  }

  async getVehicles({ companyId }) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: postData });
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    this.vehicles = response?.data?.vehicleData;
    return response?.data?.vehicleData;
  }

  async deleteRecord({ er_Id }) {
    const params = { er_Id };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .delete("/EmailReport/deleteEmailData", { params });
    // const postData = { er_Id: er_Id };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=delete", "postData=" + base64Input);

    return response;
  }

  async getEmailReportData(Id, companyId) {
    const params = { Id: Id, companyId: companyId };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("/EmailReport/getErList", { params });

    // var postData = { Id: Id, companyId: companyId, limit: 1, offset: 0 };
    // const base64Input = await base64_encode(JSON.stringify(postData));

    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=emailreport&a=getErList", "postData=" + base64Input);

    return response?.data?.data[0];
  }

  async getReportsName() {
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=report&a=getReport");

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("/EmailReport/getReportsList");

    this.reportsList = response.data.data;
    return response.data.data;
  }

  async getVehicleGroup({ companyId, userId, isadmin }) {
    var postData = { companyId: companyId, userId: userId, isadmin: isadmin };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=devicegroup&a=getVehicleGropups",
    //     "postData=" + base64Input
    //   );

    // this.groupList = response.data.data;

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("deviceGroup/getVehicleGroups", { params: postData });
    this.groupList = response?.data?.VehicleGroupData;
    //console.log(this.groupList);
  }

  async getVehicleSubGroup({
    deviceGroupId,
    deviceSubGroupId,
    companyId,
    userId,
    isadmin,
    subgroup,
  }) {
    var postData = {
      deviceGroupId: deviceGroupId,
      deviceSubGroupId: deviceSubGroupId,
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=devicegroup&a=getGroups", "postData=" + base64Input);
    if (subgroup) {
      this.subGroupList = response.data.data?.subgroup;
    } else {
      this.vehicles = response.data.data?.vehicles;
    }

    return response.data.data?.subgroup;
  }
}

export default EmailReportStore;
